import { createRoute } from '@tanstack/react-router';

import { profilePageLoadable } from 'pages/profile-page';

import { AuthenticatedRoute } from '../authenticated-route';

export const ProfileRoute = createRoute({
  getParentRoute: () => AuthenticatedRoute,
  path: '/profile',
  component: profilePageLoadable,
});
